export const LOADING_FILE = "LOADING_FILE";
export const GET_FILE_LIST = "GET_FILE_LIST";
export const REMOVE_FILE = "REMOVE_FILE";
export const ADD_FILE = "ADD_FILE";
export const UPDATE_FILE = "UPDATE_FILE";